import { useState } from 'react';
import type { ScoredGeography } from '@/types/insights';
import { exportGeographiesToCsv } from '@/export/csvExport';
import { exportSummaryPdf, exportGeoDetailPdf } from '@/export/pdfExport';

interface ExportMenuProps {
  allGeographies: ScoredGeography[];
  selected?: ScoredGeography | null;
}

export function ExportMenu({ allGeographies, selected }: ExportMenuProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="export-menu">
      <button type="button" onClick={() => setOpen((v) => !v)} className="export-menu__trigger">
        Export
      </button>
      {open && (
        <div className="export-menu__list" role="menu">
          <button type="button" onClick={() => exportGeographiesToCsv(allGeographies)}>
            All counties -- CSV
          </button>
          <button type="button" onClick={() => exportSummaryPdf(allGeographies)}>
            All counties -- PDF summary
          </button>
          {selected && (
            <button type="button" onClick={() => exportGeoDetailPdf(selected)}>
              {selected.record.geoName} County -- PDF detail
            </button>
          )}
        </div>
      )}
    </div>
  );
}
